
  import Header from '@/components/core/Header';
  import BackHeader from '@/components/core/BackHeader';


  export default {
    components: {
      Header,
      BackHeader

    },
    head() {
    return {
      meta: [
        { hid: 'og:url',
        property: 'og:url',
        content: this.$config.siteUrl + this.$route.path
      },
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: 'https://www.goa.app' + this.$route.path
        }
      ]
    }
  },
  }

